"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toBytes32Array = void 0;
const tiny_invariant_1 = __importDefault(require("tiny-invariant"));
const toBytes32Array = (b) => {
    (0, tiny_invariant_1.default)(b.length <= 32, `invalid length ${b.length}`);
    const buf = Buffer.alloc(32);
    b.copy(buf, 32 - b.length);
    return Array.from(buf);
};
exports.toBytes32Array = toBytes32Array;
